import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { listActivities } from './ActivityClient';
import { CurrentUserContext } from 'Components/Participant/Auth/RequiresCurrentUserContext';

import ActivityRow from './ActivityRow';
import Error from 'Components/Form/Error';
import StravaInfo from 'Components/Participant/Strava/StravaInfo';
import Navigation from 'Components/Page/Navigation';

import { DateTime } from 'luxon';

const sort = ( data ) =>
{
    if ( data?.items?.sort )
    {
        data.items = data.items.sort ( ( a, b ) => DateTime.fromISO ( b.createdAt ) - DateTime.fromISO ( a.createdAt ) );
    }

    return data;
}

function ActivityLog () 
{
    const navigate = useNavigate ();

    const { currentUser, customAttributes } = useContext ( CurrentUserContext );
    
    const [ isLoading, setIsLoading ] = useState ( false );
    const [ error, setError ] = useState ( { isError: false, message: null } );
    const [ activities, setActivities ] = useState ( null );

    useEffect ( () => {

        if ( isLoading === false && activities === null )
        {
            setIsLoading ( true );

            listActivities ( currentUser )
                .then ( response => {
                    setActivities ( sort ( response.data ) )
                    setIsLoading ( false );
                    setError ( { isError: false, message: null } )                    
                } )
                .catch ( error => {
                    setActivities ( [] );
                    setIsLoading ( false );
                    setError ( { isError: true, message: error?.message ? error.message : JSON.stringify ( error ) } )
                } );
        }

    }, [ isLoading, currentUser, activities ] );

    return  <>
                <div className="flex justify-between pb-6">
                    <h1 className="p-0">My activity log</h1>
                    <button className="m-0" onClick={ () => navigate ( "/participant/secure/add" ) }>Add km</button>
                </div>
                
                { error.isError && <Error message={error.message} /> }
                <table className="w-full table-auto">
                    <tbody>
                        { activities?.items?.map && activities.items.map ( activity => <ActivityRow key={activity.id} activity={activity} /> ) }
                    </tbody>
                </table>
                { activities?.items?.length === 0 && <p>You have no logged activity yet</p>}
                { customAttributes && <div className="rounded-xl bg-pgdarkteal text-pgwhite p-4 font-bold mt-6">
                        Your teams: { customAttributes["custom:location"] } &rarr;  { customAttributes["custom:region"] } &rarr;  { customAttributes["custom:team"] }
                    </div> }

                <StravaInfo />
                <Navigation />
            </>
}

export default ActivityLog;
